<template>
    <!-- <BModal
        v-model="isOpen"
        :title="$t('job_alert.create')"
        :hide-header="false"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        @hidden="close"
        modal-class="af-modal"
    > -->
    <C1Modal
        v-model="isOpen"
        modal-content-class="afu-p-4 md:afu-p-8 md:afu-pt-6"
        size="xl"
        @close="close"
    >
        <template v-slot:body>
            <div class="afu-flex afu-items-center afu-justify-between afu-mb-8">
                <div class="afu-flex afu-items-center af-text--4xl afu-text-black sm:afu-px-2">
                    <span class="afu-mr-3 afu-text-900">
                        <FontAwesomeIcon 
                            :icon="['far', 'bell']"
                        />
                    </span>
                    <span class="afu-font-bold">
                        {{ $t('job_alert.create') }}
                    </span>
                </div>
                <a
                    href="#"
                    class="afu-text-neutral-dark afu-text-2xl"
                    @click.stop.prevent="close()"
                >
                    <FontAwesomeIcon :icon="['fal', 'times']" />
                </a>
            </div>
            <div class="afu-block afu-items-center afu-justify-center">
                <CreateJobAlert 
                    :is-modal="true" 
                    @jobAlertCreated="alertCreated"
                    @jobAlertClose="close()"
                />
            </div>
        </template>
    </C1Modal>
    
    <!-- </BModal> -->
</template>

<script>
    import CreateJobAlert from '@/apps/af-page/001/components/CreateJobAlert';
    import C1Modal from '@/components/C1Components/C1Modal';

    export default {
        name: 'CreateJobAlertModal',

        components: {
            C1Modal,
            CreateJobAlert,
        },

        data() {
            return {
                isOpen: false,
                loader: {
                    destroy: false,
                },
            };
        },

        created() {
            this.openModal();
        },

        beforeDestroy() {
            this.closeModal();
        },

        methods: {
            alertCreated(){
                this.close();
                this.$emit('alertCreated');
            },

            close() {
                this.$emit('close');
            },

            openModal() {
                this.isOpen = true;
            },

            closeModal() {
                this.isOpen = false;
            },
        },
    };
</script>
